import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, BarChart3 } from 'lucide-react';
import { verifyEmail } from '../utils/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('pending'); // pending | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'This verification link is invalid or has expired.');
      });
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, background: 'linear-gradient(135deg,#3B82F6,#8B5CF6)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
            <BarChart3 size={24} color="#fff" />
          </div>
          <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 800 }}>Unbrand</h1>
        </div>

        <div style={{ background: '#fff', borderRadius: 16, padding: '32px 36px', boxShadow: '0 25px 50px rgba(0,0,0,.4)', textAlign: 'center' }}>
          {status === 'pending' && <p style={{ color: 'var(--text2)', fontSize: 13 }}>Verifying...</p>}

          {status === 'success' && (
            <>
              <CheckCircle2 size={40} color="var(--success)" style={{ marginBottom: 12 }} />
              <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Email verified</h2>
              <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>Your account is now active.</p>
              <Link to="/login" className="btn btn-primary btn-lg" style={{ justifyContent: 'center', width: '100%' }}>
                Continue to login
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <XCircle size={40} color="var(--danger, #DC2626)" style={{ marginBottom: 12 }} />
              <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Verification failed</h2>
              <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20 }}>{message}</p>
              <Link to="/login" className="btn btn-secondary" style={{ justifyContent: 'center', width: '100%' }}>
                Back to login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
